export const SITE_IMAGES_QUERY_KEY = () => ["siteImages"];
